import React, { useEffect } from "react";

const ErrorPopup = ({ message, onClose, timeout = 3000 }) => {
  // Auto-close the popup after the specified timeout (default: 5 seconds)
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, timeout);
      return () => clearTimeout(timer);
    }
  }, [message, onClose, timeout]);

  if (!message) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1001, // Background Overlay
      }}
      onClick={onClose} // Close on clicking outside
    >
      <div
        className="text-[#f87171]  border-[0.4dvh] border-solid border-[#f87171] flex justify-center items-center relative min-h-[14dvh]  min-w-[22dvh]"
        style={{
          background: "white",
          padding: "1.5dvh",
          borderRadius: "1.5dvh",
          boxShadow: "0px 0px 10px rgba(0,0,0,0.3)",
          textAlign: "center",
          maxWidth: "50dvw",
          position: "relative", // Ensure absolute positioning works
          zIndex: 1002, // Popup should be above overlay
        }}
        onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside the popup
      >
        <p className="font-bold text-5xl text-center  text-[#f87171]">
          {message}
        </p>
      </div>
    </div>
  );
};

export default ErrorPopup;
